import { render } from "./shop-area.vue?vue&type=template&id=8e7eeb8a&scoped=true"
import script from "./shop-area.vue?vue&type=script&lang=js"
export * from "./shop-area.vue?vue&type=script&lang=js"

import "./shop-area.vue?vue&type=style&index=0&id=8e7eeb8a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e7eeb8a"]])

export default __exports__